<template>
  <div class="sample-database-detail dashboard-card">
    <div class="sample-database-detail-header" @click="back();">
      <MenuLeftIcon />
    </div>
    <div class="sample-database-detail-body">
      <div class="sample-database-detail-title">
        <h4>{{ $t(popData.name) }}</h4>
      </div>
      <b-row>
        <b-col cols="12" md="3" lg="3">
          <div class="pop-desc">
            <div class="title-header">
              <h5>{{ $tI('Sample ID title') }}</h5>
            </div>
            <hr />
            <div class="desc">
              {{ $t(popData.sampleID) }}
            </div>
          </div>
          <div class="pop-desc">
            <div class="title-header">
              <h5>{{ $tI('Date column title') }}</h5>
            </div>
            <hr />
            <div class="desc">
              {{ tData }}
            </div>
          </div>
          <div class="pop-desc">
            <div class="title-header">
              <h5>{{ $tI('Dating Method') }}</h5>
            </div>
            <hr />
            <div class="desc">
              {{ popData.datingMethod }}
            </div>
          </div>

          <div class="pop-desc">
            <div class="title-header">
              <h5>{{ $tI('Location column title') }}</h5>
            </div>
            <hr />
            <div class="desc">
              {{$t(popData.location)}}
            </div>
          </div>

          <div class="pop-desc">
            <div class="title-header">
              <h5>{{ $tI('Study') }}</h5>
            </div>
            <hr />
            <div class="desc">
              {{$t(popData.study)}}
            </div>
          </div>

          <div class="pop-desc">
            <div class="title-header">
              <h5>{{ $tI('Doi') }}</h5>
            </div>
            <hr />
            <div class="desc">
              {{$t(popData.doi)}}
            </div>
          </div>
        </b-col>

        <b-col cols="12" md="5" lg="5">
          <div class="title-header">
            <h5>{{ $tI('Genetic Profile title') }}</h5>
          </div>
          <hr />
          <div class="p-1">
            <h5 v-if="!farmerHgResultList">{{ $tI('Unavailable') }}</h5>
            <template v-else>
              <div v-for="itemAncestry in farmerHgResultList.resultList" :key="itemAncestry.resultName" class="farmer-hgs">
                <span class="label">
                  {{ $tPop(itemAncestry.resultName, 'title',  itemAncestry.resultName.replaceAll('*', ' ')) }}:
                </span>
                <span class="percent"><b>{{ itemAncestry.resultValue.toFixed(1) }}%</b></span>
              </div>
            </template>
          </div>
        </b-col>
        <b-col cols="12" md="4" lg="4">
          <div class="title-header">
            <h5>{{ $tI('Genetically Closest Populations table title') }}</h5>
          </div>
          <hr />
          <div class="dist-table-container">
            <div class="dist-tab"
              v-for="(tab) in $store.state.sampleDatabase.distanceTypes" :key="tab" 
              :class="{ 'active': tab === $store.state.sampleDatabase.distanceType }"
              @click="$store.state.sampleDatabase.distanceType = tab"
            >
              {{ $tI(tab) }}
            </div>
          </div>
          <div class="distance-container mt-2">
            <table class="table table-striped distance-table">
              <thead class="table-light">
                <tr>
                  <th scope="col">{{ $tI('Distance title') }}</th>
                  <th scope="col">{{ $tI('Modern population title') }}</th>
                </tr>
              </thead>
              <tbody v-show="$store.state.sampleDatabase.distanceType === 'Modern'">
                <tr v-for="distanceItem in distanceList" :key="distanceItem.title">
                  <td><span class="td-size" :style="{ color: distanceItem.gradHSL }"> {{ distanceItem.distance }}</span></td>
                  <td>{{$t(distanceItem.title.replaceAll('*', ' '))}}</td>
                </tr>
              </tbody>
              <tbody v-show="$store.state.sampleDatabase.distanceType === 'Ancient'">
                <tr v-for="distanceItem in distanceAncientList" :key="distanceItem.title">
                  <td><span class="td-size" :style="{ color: distanceItem.gradHSL }"> {{ distanceItem.distance }}</span></td>
                  <td>{{$t(distanceItem.title.replaceAll('*', ' '))}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
      
      <div class="sample-database-detail-refs">
        <div class="title-header mb-3">
          <h5>{{ $tI('Reference Samples Details') }}</h5>
        </div>
        <b-row>
          <b-col cols="12" md="3" lg="3">
            <div class="pop-desc">
              <div class="title-header">
                <h5>{{ $tI('Y DNA column title') }}</h5>
              </div>
              <hr />
              <div class="desc">
                <ul>
                  <li v-for="item in yDna" :key="item">
                    {{item}}
                  </li>
                </ul>
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="3" lg="3">
            <div class="pop-desc">
              <div class="title-header">
                <h5>{{ $tI('mtDNA column title') }}</h5>
              </div>
              <hr />
              <div class="desc">
                <ul>
                  <li v-for="item in mtDna" :key="item">
                    {{item}}
                  </li>
                </ul>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { tDateParser } from '@/services/Base/utils'
import MenuLeftIcon from '@/components/icons/MenuLeftIcon'

export default {
  components: {
    MenuLeftIcon,
  },
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
    back() {
      this.$store.state.ancientIndividualDatabase.sampleDetail = null
    },
  },
  computed: {
    popData() {
      return this.$store.state.ancientIndividualDatabase.sampleDetail;
    },
    researchArray() {
      return this.popData.research ? this.popData.research.split(',') : [];
    },
    mtDna() {
      return this.popData.mtDNA ? this.popData.mtDNA.split(',') : [];
    },
    yDna() {
      const yDNA = [];
      if (this.popData.yDNAISOGG) {
        yDNA.push(this.popData.yDNAISOGG)
      }
      if (this.popData.yDNATM) {
        yDNA.push(this.popData.yDNATM)
      }
      return [...new Set(yDNA)];
    },
    tData() {
      let date = this.popData.date;

      if(date) {
        const dateObj = tDateParser(date);
        date = this.$tParams(dateObj.key, dateObj.params, dateObj.value, this.popData.date);
      }

      return date;
    },

    distanceList() {
      return this.$store.state.sampleDatabase.calculatedDistance;
    },
    distanceAncientList() {
      return this.$store.state.sampleDatabase.calculatedDistanceAncient;
    },
    farmerHgResultList() {
      return this.$store.state.sampleDatabase.calculatedFarmerHgResult;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
</style>
